import Customer from '@/customer/models/Customer';

export interface CustomerList {
  data: Customer[];
  total: number;
  refreshCounter: number;
}

const customerList: CustomerList = {
  data: [],
  total: 0,
  refreshCounter: 0,
};

export default customerList;
